export const isFnO = (exchange: string) => {
  if (!exchange) return false;

  return exchange === 'NFO' || exchange === 'BFO';
};
